import styled from 'styled-components';
import Container from '@/components/Global/Container';
import { rem } from 'polished';

const SWBasketStyles = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const SWBasketContainer = styled(Container)``;

// BASKET HEADER
export const ContainerHeaderStyles = (width: number) => ({
  backgroundColor: 'primary2.default',
  pt: width <= 768 ? rem('32px') : rem('52px'),
  pb: width <= 768 ? rem('32px') : rem('44px'),
});

export const SWBasketHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  > h3,
  > p {
    color: var(--mineShaft);
  }

  p {
    width: auto;
    text-align: right;
  }

  > h3 {
    letter-spacing: ${rem('-0.3px')};
    margin: 0 auto;
    @media (min-width: ${rem('992px')}) {
      margin: 0 auto;
    }
  }
`;

// BASKET SUMMARY
export const SWBasketSummary = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  @media only screen and (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    align-items: flex-start;
  }
`;

export const SWBasketSummaryInner = styled.div`
  padding: ${rem('30px')} 0;
  width: 100%;

  > h2 {
    color: var(--mineShaft);
    @media only screen and (min-width: ${({ theme }) => theme.breakpoints.md}px) {
      margin-bottom: ${rem('30px')};
    }
  }
`;

// EMPTY BASKET
export const EmptyBasket = styled.div`
  display: flex;
  background: #ffffff;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  border-radius: ${rem('6px')};
  padding: ${rem('80px')} ${rem('20px')} ${rem('50px')};
  margin: ${rem('40px')} ${rem('0px')};

  > h3,
  > p {
    margin: ${rem('3px')} 0;
    color: var(--mineShaft);
  }

  > p {
    margin-top: ${rem('30px')};
    font-family: 'VodafoneLight';
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md - 1}px) {
    padding: ${rem('40px')} ${rem('20px')} ${rem('10px')};

    > h3 {
      font-size: ${rem('28px')};
      line-height: ${rem('32px')};
    }

    > p {
      font-size: ${rem('20px')};
      line-height: ${rem('28px')};
    }
  }
`;

// BASKET TOTAL
export const SWBasketTotal = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: ${rem('30px')};
  border-top: ${rem('1px')} solid #33333380;
  @media (max-width: ${({ theme }) => theme.breakpoints.md - 1}px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const SWBakestTotalPrices = styled.div`
  display: flex;
  > * {
    margin-right: ${rem('100px')};
    &:last-child {
      margin-right: 0;
    }
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.md - 1}px) {
    width: 100%;
    justify-content: flex-start;
    align-self: flex-end;

    [class*='HeadingPrice'] h4 {
      font-size: ${rem('24px')};
    }
  }
`;

// BASKET ACTION BUTTONS

export const WrapperBasketButtons = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${rem('30px')} 0;

  #basket-button-complete-purchase {
    width: 100%;
    max-width: ${rem('201px')};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    justify-content: space-between;
    flex-direction: row;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.md - 1}px) {
    width: 100%;
    #basket-button-complete-purchase {
      max-width: 100%;
    }
  }
`;

export const BasketButtonsInner = styled.div`
  display: flex;
  flex-direction: column;
  a,
  button {
    margin-bottom: ${rem('10px')};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    flex-direction: row;
    a,
    button {
      margin-right: ${rem('16px')};
      margin-bottom: 0;
    }
  }
`;

//Basket Information for mobile view

export const BasketMoreInformationWrapper = styled.div`
  display: none;
  margin-top: ${rem('20px')};
  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    display: block;
  }
`;

export const SWHorizontalStepper = styled.div<{ currentStep: number }>`
  border-bottom: ${rem('1px')} solid #33333380;
  padding: ${rem('40px')} 0 ${rem('30px')};
  background-color: #f4f4f4;
  width: 100%;
  [class*='HorizontalStepperstyle'] {
    div::before {
      border: 0;
      right: calc(50%);
      @media (max-width: ${({ theme }) => theme.breakpoints.md - 1}px) {
        right: calc(50%);
      }
    }
    div:nth-child(${props => props.currentStep}) {
      &::after {
        background-color: red !important;
        left: calc(50% + 10px + 0px);
        @media (max-width: ${({ theme }) => theme.breakpoints.md - 1}px) {
          left: calc(50%);
        }
      }
    }
  }
  [class*='Stepstyle__Circle'] {
    box-shadow: none !important;
  }
  [class*='Stepstyle__StepTitle'] {
    font-weight: 400;
    font-family: 'VodafoneLight';
  }
  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    border-bottom: none;
  }
`;

export default SWBasketStyles;
